<template>
  <div style="user-select: text !important;">
    <!-- {{form.data}} -->
    <el-descriptions title="" :column="1" border>
      <el-descriptions-item
        :label="item.type === 'depict' ? '' : item.__config__.label"
        v-for="(item, index) in form_config.filter(v => checkVisibility(v)).filter(k => !['fee'].includes(k.type))"
        :key="index"
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
      >
      <!-- {{!item.visible || !!item.visible && (form.data[item.visible.key] == item.visible.value) }} -->
      <!-- {{item.visible && (form.data[item.visible.key] == item.visible.value[0]) || item.visible && (form.data[item.visible.key] == item.visible.value[1]) || item.visible && (form.data[item.visible.key] == item.visible.value[2]) || !item.visible}} -->

          <!-- 关联审批单 -->
            <template v-if="item.type === 'approval'">
              <div>
                <div
                  class="flex approval_item"
                  style="margin:0 10px;"
                  v-for="(aitem, aindex) in setstr(
                    item.__config__.defaultValue,
                    item.type,
                    item.__config__.tag
                  )"
                  :key="aindex"
                >
                  <el-button type="text" size="small" @click="show(item, aindex)">
                    {{aitem.employee.name}}提交的
                    {{
                    aitem.approval_name
                    }}</el-button>
                  <span :class="'status' + aitem.status">
                    {{ setstatus(list, aitem) }}</span
                  >
                </div>
              </div>
            </template>
            <!-- 收款信息 -->
            <template v-else-if="item.type === 'payInfo'">
              <div>
                <div
                  class="flex approval_item2"
                  style="margin:0 10px;"
                  v-for="(aitem, aindex) in setstr(
                    item.__config__.defaultValue,
                    item.type,
                    item.__config__.tag
                  )"
                  :key="aindex"
                >
                  <div style="margin-right:10px;color:#909399">{{aitem.label}}:</div>
                  <div style="">{{aitem.value}}</div>
                </div>
              </div>
            </template>
            <!-- 签名 -->
            <template
              v-else-if="
                item.typeId === 'SIGN_PAD' || item.__config__.tag === 'sign-pad'
              "
            >
              <el-image
                v-if="!!JSON.parse(item.__config__.defaultValue)"
                @click.native="
                  showImg(
                    setstr(
                      item.__config__.defaultValue,
                      item.type,
                      item.__config__.tag
                    ),
                    1
                  )
                "
                style="width: 120px; height: 60px"
                :src="
                  setstr(
                    item.__config__.defaultValue,
                    item.type,
                    item.__config__.tag
                  )
                "
                :preview-src-list="[
                  setstr(
                    item.__config__.defaultValue,
                    item.type,
                    item.__config__.tag
                  ),
                ]"
                fit="contain"
              ></el-image>
              <span v-else></span>
            </template>
            <template v-else-if="item.type === 'img'">
              <span
                v-for="(img, imgindex) in setstr(
                  item.__config__.defaultValue,
                  item.type,
                  item.__config__.tag
                )"
                :key="imgindex"
                @click="
                  showImg(
                    setstr(
                      item.__config__.defaultValue,
                      item.type,
                      item.__config__.tag
                    ),
                    2
                  )
                "
              >
                <el-image
                  v-if="img.url"
                  style="margin:5px;width: 40px; height: 40px; margin-right: 10px"
                  :src="img.url"
                  :preview-src-list="
                    setstr(
                      item.__config__.defaultValue,
                      item.type,
                      item.__config__.tag
                    ).map((img) => img.url)
                  "
                  fit="cover"
                ></el-image>
              </span>
            </template>
            <template v-else-if="item.type === 'attach'">
              <div v-for="(file2, fileindex2) in item.__config__.sample"
                :key="fileindex2">
                <el-link type="info" style="margin:5px 12px;" target="_blank" @click="handlePreview(file2)">{{ file2.name || file2.fileName }}</el-link>
                <el-button
                  type="text"
                  size="mini"
                  style="border: solid 1px #ff6600;border-radius: 6px;padding: 2px 5px;color: #ff6600;"
                  @click="download(file2.url || file2.path, file2.name || file2.fileName)"
                >示例</el-button>
              </div>
              <div v-for="(file, fileindex) in setstr(
                    item.__config__.defaultValue,
                    item.type,
                    item.__config__.tag
                  )"
                  :key="fileindex">
                <div style="display: flex;align-items: self-start;">
                  <el-link type="primary" :disabled="!file.url && !file.path" class="attach" style="margin:5px 12px;flex: 1;" target="_blank" @click="handlePreview(file)">{{ file.name || file.fileName }}</el-link>
                  <el-button
                    type="text"
                    size="mini"
                    :disabled="!file.url && !file.path"
                    style="margin-right:10px;"
                    @click="download(file.url || file.path, file.name || file.fileName)"
                  >下载</el-button>
                </div>
                <div style="color:#E6A23C;font-size:12px;text-align: right;padding-right: 10px;">{{getCanSee(file)}}</div>
              </div>
            </template>
            <template v-else-if="item.type === 'file'">
              <div v-for="(file, fileindex3) in setstr(
                    item.__config__.defaultValue,
                    item.type,
                    item.__config__.tag
                  )"
                  :key="fileindex3">
                <div style="display: flex;align-items: self-start;">
                  <el-link :disabled="!file.url && !file.path" class="attach" type="primary" style="margin:5px 12px;flex: 1;" target="_blank" @click="handlePreview(file)">{{ file.name || file.fileName }}</el-link>
                  <el-button
                    type="text"
                    size="mini"
                    :disabled="!file.url && !file.path"
                    style="margin-right:10px;"
                    @click="download(file.url || file.path, file.name || file.fileName)"
                  >下载</el-button>
                </div>
                <div style="color:#E6A23C;font-size:12px;text-align: right;padding-right: 10px;">{{getCanSee(file)}}</div>
              </div>
            </template>
            <!-- 表格 -->
            <template v-else-if="item.__config__.tag === 'EditTable'">
              <el-table
                :data="
                  setstr(
                    item.__config__.defaultValue,
                    item.type,
                    item.__config__.tag
                  )
                "
                border
                width="100%"
              >
                <el-table-column
                  :prop="i.prop"
                  :label="i.label"
                  v-for="i in item.columns"
                  :key="i.prop"
                >
                </el-table-column>
              </el-table>
            </template>
            <template v-else>
              <div v-if="item.type === 'depict'" class="bgrow" style="padding:10px 12px;">
                <div v-html="setstr(item.__config__.label , item.type, item.__config__.tag)"></div>
              </div>
              <div v-else style="padding:10px 12px;">
                <div v-html="setstr(item.__config__.defaultValue, item.type, item.__config__.tag).replace(/\\n/g, '<br>').replace(/\\t/g, '')"></div>
              </div>
            </template>
      </el-descriptions-item>
    </el-descriptions>
    <template v-if="feeData.length && hasFee()">
    <div style="margin-top:10px;margin-bottom:10px">费用报销单: 总金额¥‌{{feeDataTotal}}({{convertToUpperCase(feeDataTotal*1)}})</div>
    <el-table
      :data="feeData"
      border
      style="width: 100%">
      <el-table-column
        align="center"
        prop="feeName"
        label="费用类型"
        >
      </el-table-column>
      <el-table-column
        align="center"
        prop="happenDate"
        label="发生日期"
        >
      </el-table-column>
      <el-table-column
        align="center"
        prop="personNum"
        label="人数">
      </el-table-column>
      <el-table-column
        align="center"
        prop="summary"
        label="摘要">
      </el-table-column>
      <el-table-column
        align="center"
        prop="reissueReason"
        label="报销事由">
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="金额">
      </el-table-column>
    </el-table>
    </template>
    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <flowTop :dataInfo="dataInfo"></flowTop>
      <formcontent :form_config="formlist"></formcontent>
     <h3 class="mt20">
      审批流程<span
        v-if="dataInfo.auto_pass == 1"
        style="font-size: 14px; color: #409eff"
        >(已启动自动去重)</span
      >
      </h3>
      <flowList
        :flow_list="flow_list"
        :dataInfo="dataInfo"
        :stepsActive="stepsActive"
      ></flowList>
    </el-dialog>

    <!-- 查看图片 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="previewImages"
    />

    <!-- 预览文件 -->
    <VueOfficeView ref="fileView" :fileType="fileType" :fileUrl="fileUrl" :fileName="fileName" ></VueOfficeView>

    <!-- <el-dialog
      title="ofd文件预览"
      :visible.sync="dialogVisibleOfd"
      width="60%">
      <cafe-ofd style="width:100%;height: 60vh," ref="ofd" :filePath="urlofd" > </cafe-ofd>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleOfd = false">确 定</el-button>
      </span>
    </el-dialog> -->

  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import flowList from "@/components/flowList.vue";
import flowTop from "@/components/flowTop.vue";
import VueOfficeView from '@/components/VueOfficeView.vue'
import { mixinTable } from "@/mixins/table.js";
import { mixinPreview } from "@/mixins/filepreview.js";

export default {
  name: "Formcontent",
  mixins: [mixinTable,mixinPreview],
  props: {
    form_config: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ElImageViewer,
    flowList,
    VueOfficeView,
    flowTop,
  },
  data() {
    return {
      dialogVisible: false,
      labelStyle: { width: "150px" },
      contentStyle: { width: "320px" },
      formlist: [],
      showViewer: false,
      previewImages: [],
      list: "[]",
      dataInfo: {},
      stepsActive: 0,
      flow_list: [],
      form:{
        data: {},
      },
      isShow:false,
      dialogVisibleOfd: false,
      urlofd: 'https://qn.cdn.jszhr.com/oa/20250319/0721d8a517609e29aba7cbef9d675153.ofd',
      //费用报销单
      feeData:[],
      feeDataTotal:0
    };
  },
  watch: {
    form_config(newVal,oldVal) {
      newVal.forEach((obj) => {
        this.$set(this.form.data, obj.__vModel__, "");
        this.form.data[obj.__vModel__] = JSON.parse(obj.__config__.defaultValue);
        if(this.form.data.hasOwnProperty(obj.__vModel__) && obj.__config__.tag == 'el-radio-group') {
          this.form.data[obj.__vModel__] = JSON.parse(obj.__config__.defaultValue).value || '';
        }else if(this.form.data.hasOwnProperty(obj.__vModel__) && obj.__config__.tag == 'el-checkbox-group') {
        this.form.data[obj.__vModel__] = JSON.parse(obj.__config__.defaultValue).map(item => item.value) || [];
        }
      });
      let obj = this.form_config.find((item) => item.type === "fee");
      if (obj) {
        this.feeData = JSON.parse(obj.__config__.defaultValue);
        this.feeDataTotal = obj.__config__.total_money;
      }
      console.log(this.form_config,'this.form_config')
    }
  },
  mounted() {
    this.form_config.forEach((obj) => {
      this.$set(this.form.data, obj.__vModel__, "");
      this.form.data[obj.__vModel__] = JSON.parse(obj.__config__.defaultValue);
      if(this.form.data.hasOwnProperty(obj.__vModel__) && obj.__config__.tag == 'el-radio-group') {
        this.form.data[obj.__vModel__] = JSON.parse(obj.__config__.defaultValue).value || '';
      }else if(this.form.data.hasOwnProperty(obj.__vModel__) && obj.__config__.tag == 'el-checkbox-group') {
        this.form.data[obj.__vModel__] = JSON.parse(obj.__config__.defaultValue).map(item => item.value) || [];
      }
    });
    console.log(this.form_config,'this.form_config')
    console.log(this.form.data,'this.form.data')
    let obj = this.form_config.find((item) => item.type === "fee");
    if (obj) {
      this.feeData = JSON.parse(obj.__config__.defaultValue);
      this.feeDataTotal = obj.__config__.total_money;
    }
  },
  methods: {
    hasFee() {
      if(this.form_config.find((item) => item.type === "fee")) {
        return true
      }else {
        return false
      }
    },
    // 检查控件是否应该显示（支持多个单选项.多选项关联）
    checkVisibility(item) {
      // 如果没有visible属性，则始终显示
      if (!item.visible) return true;
      // 如果visible是数组（新格式）
      if (Array.isArray(item.visible)) {
        // 任一条件满足即可（OR关系）
        return item.visible.some(condition => {
          // 如果表单中没有该字段的值，则此条件不满足
          if (!this.form.data[condition.key]) return false;
          
          // 处理多选项的情况（当表单值是数组时）
          if (Array.isArray(this.form.data[condition.key])) {
            // 检查表单数组中是否有任何值在condition.value数组中
            return this.form.data[condition.key].some(val => 
              condition.value.includes(val) || condition.value.includes(val.value)
            );
          }
          
          // 处理单选项的情况
          return condition.value.includes(this.form.data[condition.key]) || 
          condition.value.map(k => String(k)).includes(String(this.form.data[condition.key])) ||
          condition.value.map(k => String(k)).includes(String(this.form.data[condition.key].value))
        });
      }
      
      // 如果visible是对象（旧格式，向后兼容）
      if (this.form.data[item.visible.key]) {
        // 处理多选项的情况（当表单值是数组时）
        if (Array.isArray(this.form.data[item.visible.key])) {
          return this.form.data[item.visible.key].some(val => 
            item.visible.value.includes(val) 
          );
        }
        
        // 处理单选项的情况
        return item.visible.value.includes(this.form.data[item.visible.key]) 
        || item.visible.value.includes(this.form.data[item.visible.key].value) 
        || item.visible.value == this.form.data[item.visible.key]
        || item.visible.value == this.form.data[item.visible.key].value;
      }
      
      return false;
    },
    
    show(item, aindex) {
      let defaultValue = JSON.parse(item.__config__.defaultValue); 
      // if (item.__config__.defaultValue.indexOf("form_content") != -1) {
      //   let form =
      //     typeof defaultValue[aindex].form_content == "object"
      //       ? defaultValue[aindex].form_content
      //       : JSON.parse(defaultValue[aindex].form_content);
      //   this.formlist = form.fields;
      //   this.getDetail(defaultValue[aindex].id)
      //   this.dialogVisible = true;
      // }
      this.getDetail(defaultValue[aindex].id)
      this.dialogVisible = true;
    },
    setstatus(list, item) {
      let l = JSON.parse(list);
      let s = l
        .filter((i) => i.id == item.id)
        .map((i) => i.status)
        .join(",");
      return { 1: "审批中", 2: "已撤回", 3: "审批通过", 4: "拒绝" }[s];
    },
   
    setstr(v, type, tag) {
      if (!v || (!v.replace(/"/gi, "") && typeof v == "string")) return "";
      let str = "";
      if (type == "department") {
        str = v;
      }  else if (type == "departments") {
        str = JSON.parse(v)
          .map((i) => i.name)
          .join(",");
      }
      else if (type == "company") {
        str = JSON.parse(v)
          .map((i) => i.name)
          .join(",");
      } else if (type == "textarea") {
        str = v;
      } else if (type == "purchase_type") {
        str = JSON.parse(v)
          .map((i) => i.name)
          .join(",");
      } else if (type == "leave_type") {
        str = JSON.parse(v)
          .map((i) => i.name)
          .join(",");
      } else if (type == "signet") {
        str = JSON.parse(v)
          .map((i) => i.name)
          .join(",");
      } else if (type == "projectName") {
        str = `${JSON.parse(v).name}`
      }
      else if (type == "aptitude") {
        str = JSON.parse(v)
          .map((i) => i.name)
          .join(",");
      } else if (type == "car") {
        str = JSON.parse(v)
          .map((i) => i.code || i.name)
          .join(",");
      } else if (type == "employee") {
        str = JSON.parse(v)
          .map((i) => i.name)
          .join(",");
      } else if (type == "select") {
        str = JSON.parse(v)
          .map((i) => i.label)
          .join(",");
      } else if (type == "date") {
        str = v;
      } else if (type == "datetime") {
        str = v;
      } else if (type == "role") {
        str = v;
      } else if (type == "input") {
        str = v.replace(/\n/g, '<br>');
      } else if (type == "entry_at") {
        str = v;
      } else if (type == "idcard") {
        str = v;
      } else if (type == "phone") {
        str = v;
      } else if (type == "duration") {
        str = v;
      } else if (type == "number") {
        str = v;
      } else if (type == "amount") {
        let m = v.replace(/"/g, '');
        str = v+`（${this.convertToUpperCase(m*1)}）`;
      } else if (type == "remark") {
        str = v;
      } else if (type == "depict") {
        str = v;
      } else if (type == "datetime") {
        str = v;
      } else if (type == "approval") {
        str = JSON.parse(v);
        str.length &&
          this.$http
            .get("/admin/employeeApproval/commonStatus", {
              params: { ids: str.map((item) => item.id).join(",") },
            })
            .then((res) => {
              this.list = JSON.stringify(res.data.list);
            });
        console.log(str,"审批关联")
        return str;
      } else if (type == "attach") {
        str = JSON.parse(v);
        return str;
      } else if (type == "file") {
        str = JSON.parse(v);
        return str;
      } else if (type == "img") {
        str = JSON.parse(v);
        return str;
      }else if (type == "payInfo") {
        str = JSON.parse(v);
        let payInfoList =  Object.keys(str).map(key => {
          const valueMap = {
            payeeName:'收款人姓名',
            payeeAccount:'收款人账号',
            bankDepositL:'开户银行',
          }
          return {
            key: key,
            label: valueMap[key],
            value: str[key]
          }
        })
        return payInfoList;
      }else if (type == "datetimerange") {
        str = str = JSON.parse(v).join(" 至 ");
      } else if (type == "daterange") {
        str = JSON.parse(v).join(" 至 ");
      } else if (type == 'dxxzkradio' || tag == "el-radio-group") {
        if (v.indexOf("label") > -1) {
          str = JSON.parse(v).label;
          return str;
        } else {
          str = v;
        }
      } else if (type == 'duoxiangcheckbox' || tag == "el-checkbox-group") {
        let l = typeof v == "object" ? v : JSON.parse(v);
        str = l.map((i) => i.label || i.name).join(",");
      } else if (type == undefined && tag == "el-time-picker") {
        str = v;
      } else if (type == undefined && tag == "EditTable") {
        str = JSON.parse(v);
        return str;
      } else if (type == undefined && tag == "sign-pad") {
        str = v.replace(/"/gi, "");
        return str;
      } else if(type == 'reissue_time') {
        let obj = JSON.parse(v);
        return str = !!obj.base_time ? this.$moment.unix(obj.base_time).format("yyyy-MM-DD HH:mm") +'  '+ this.toStr({0:'未打卡',1:'正常',2:'早退',3:'迟到',4:'缺卡',5:'请假',6:'休息',7:'外勤',8:'旷工'},obj.status)+ '补卡' : '';
      }
      return str.replace(/"/gi, "")
    },
    showImg(row, type) {
      // this.showViewer = true;
      // // type 1:签名，2图片
      // if (type == 1) {
      //   this.previewImages = [row];
      // } else {
      //   this.previewImages = row.map((v) => v.url);
      // }
    },
    // 关闭查看回单
    closeViewer() {
      this.showViewer = false;
      this.previewImages = [];
    },
    download(urls, name) {
      const option = {
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
      if (window?.fetch) {
        fetch(urls, option)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            a.click();
          });
      } else {
        const a = document.createElement("a");
        a.href = urls;
        a.target = "_blank";
        a.download = name;
        a.click();
      }
    },
    getDetail(aid) {
      this.$http
        .post("/admin/employeeApproval/detail", { id: aid })
        .then((res) => {
          if (res.code == 1) {
            this.dataInfo = res.data;
            this.stepsActive = res.data.cur_flow_level - 1;
            this.formlist = res.data.form_content.fields;
            let flow_list = res.data.flow_list;
            this.flow_list = flow_list.map((item) => {
              let processor = item.processor
                ? item.processor
                    .split(",")
                    .filter((i) => i)
                    .map((i) => i * 1)
                : "";
              return {
                ...item,
                employees:
                  processor && item.person_type == 4
                    ? item.employees.filter((v) => processor.indexOf(v.id) > -1)
                    : item.employees,
              };
            });
          }
        });
    },
    remarkHTML(remark){
      return remark.replace(/\n/g, '<br>');
    },
    getCanSee(file) {
      if(file && file.flowList && file.flowList.length) {
        let str = file.flowList.map(i => i.flowName).join('、');
        return  `仅${str}可见`;
      }else {
        return ''
      }
    }
  },
};
</script>

<style scoped>
a {
  margin: 0 10px 0 0;
  color: #1890ff;
}
.approval_item {
  justify-content: space-between;
  align-items: center;
}
.approval_item2 {
  justify-content: start;
  align-items: center;
}
.status1 {
  background: transparent;
  color: #ff7e00;
}
.status2 {
  background: transparent;
  color: #999999;
}
.status3 {
  background: transparent;
  color: #1ec00d;
}
.status4 {
  background: transparent;
  color: #ff3d27;
}
::v-deep .el-descriptions-item__cell {
  padding:0 !important;
}
.bgrow {
  background: #fafafa !important;
}
.attach ::v-deep .el-link--inner {
  width: 100%;
}
</style>